import { Component, OnInit } from '@angular/core';
import { ILeftnavList } from '../../model/ILeftnavList';
import { LeftNavService } from '../../services/leftnavService';
import { PeopleProfileService } from 'src/app/services/people-profile.service';
import { PeopleProfileInfo } from 'src/app/model/PeopleProfileInfo';
declare var $;


@Component({
  selector: 'app-shortcut',
  templateUrl: './shortcut.component.html',
  styleUrls: ['./shortcut.component.css']
})
export class ShortcutComponent implements OnInit {

  iLeftnavList: ILeftnavList[] = [];
  peopleprofileinfo: PeopleProfileInfo;
  userRoleIds: string = '';
  userObject: any;

  constructor(private leftnavservice: LeftNavService, private peopleprofileservice: PeopleProfileService) {
    const jsonString = localStorage.getItem('currentUser');
    this.userObject = JSON.parse(jsonString);
  }

  ngOnInit() {

    for (var i = 0, l = this.userObject?.role.length; i < l; i++) {
      this.userRoleIds += this.userObject.role[i].roleId + ',';
    }
    this.userRoleIds = this.userRoleIds.substring(0, (this.userRoleIds.length - 1));

    setTimeout(() => {
      $(document).ready(function () {
        $('[data-toggle="tooltip"]').tooltip();
      });
    }, 500);

    this.getPeopleProfileInfoByEmailID(this.userObject.userName);

    //this.getILeftnavList(this.userRoleIds);
  }

  ngAfterViewInit() {
    $('[data-toggle="tooltip"]').tooltip();
  }

  ngAfterViewChecked() {
    $('[data-toggle="tooltip"]').tooltip({
      trigger: 'hover'
    });
    $('[data-toggle="tooltip"]').on('mouseleave', function () {
      $(this).tooltip('dispose');
    });
    $('[data-toggle="tooltip"]').on('click', function () {
      $(this).tooltip('dispose');
    });
  }

  getILeftnavList(rolesList: string, serviceLine: string) {
    if (typeof rolesList != 'undefined' && rolesList != '0' && rolesList != 'Loading') {
      this.leftnavservice.getILeftnavList(rolesList, true, serviceLine).subscribe(
        result => {
          if (result != null) {
            this.iLeftnavList = result;
          }
        },
        err => {
          console.error('Error in fetching data from get verb of LeftNav.', err);
        }
      );
    }
  }
  getPeopleProfileInfoByEmailID(emailId: string) {
    //emailId="Jerry.Winsten@us.gt.com"
    if (typeof emailId != 'undefined' && emailId != 'Loading') {
      var isRefresh = false;
      var peopleProfileJson = JSON.parse(localStorage.getItem('peopleProfile'));
      if (peopleProfileJson != null && peopleProfileJson.email != null && peopleProfileJson.email.toLowerCase() == emailId.toLowerCase()) {
        let cacheDate = new Date(peopleProfileJson.cachedDateTime)
        if ((new Date().getTime() - cacheDate.getTime()) / (1000 * 3600 * 24) >= 7) {
          isRefresh = true;
        }
        else {
          this.peopleprofileinfo = peopleProfileJson;
          this.getILeftnavList(this.userRoleIds, this.peopleprofileinfo.serviceLine);
          isRefresh = false;
        }
      }
      else
        isRefresh = true;
      if (isRefresh) {
        this.peopleprofileservice.GetPeopleProfileInfoByEmailID(emailId).subscribe(result => {
          if (result != null) {
            this.peopleprofileinfo = result;
            if (this.peopleprofileinfo.statusCode == "200") {
              /* if (this.peopleprofileinfo.serviceLine === 'Information Technology') {
                 this.peopleprofileinfo.serviceLine = 'Tax';
               }
               else*/
              if (this.peopleprofileinfo.serviceLine === 'Audit and Assurance' || this.peopleprofileinfo.serviceLine === 'ESG ＆ Sustainability') {
                this.peopleprofileinfo.serviceLine = 'Audit';
              }
              this.peopleprofileinfo.cachedDateTime = new Date().toLocaleString();
              localStorage.setItem('peopleProfile', JSON.stringify(this.peopleprofileinfo));
              this.getILeftnavList(this.userRoleIds, this.peopleprofileinfo.serviceLine);
            }

          }
        }
          ,
          err => {
            console.error('Error in fetching data using emailId.', err);
          });
      }
    }
  }

}
